import React, { memo } from 'react';
import { LoadingSpinner, VStack } from '@adc/parallax-component-library';
const LoadingBars = ({
  options
}) => {
  const testID = options?.id || 'loading-spinner';
  return /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    backgroundColor: "$surface.background",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    zIndex: 1,
    style: {
      height: '100vh',
      width: '100vw'
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    testID: testID
  }));
};
export default /*#__PURE__*/memo(LoadingBars);